import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AiSummaryApiService,
  CaseAiSummaryResponse,
  GenerateCaseAiSummaryRequest,
} from '../../../infrastructure/api/ai-summary-api.service';

@Injectable({ providedIn: 'root' })
export class GenerateCaseAiSummaryUseCase {
  private readonly _apiService = inject(AiSummaryApiService);

  public execute(
    caseId: string,
    request: GenerateCaseAiSummaryRequest
  ): Observable<CaseAiSummaryResponse> {
    return this._apiService.generateSummary(caseId, request);
  }
}
